import { useCallback } from "react";
import { useScope } from "@state/scopeContext.lib";
import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";

/** Returns a callback that switches into a client's workspace from the firm's client lists. */
export const useOpenClientWorkspace = () => {
    const { changeActiveWorkspace } = useScope();

    return useCallback(
        (workspaceId: string) => {
            changeActiveWorkspace(
                workspaceId,
                OrganizationMemberClientAccessSource.CLIENTS_LIST,
            );
        },
        [changeActiveWorkspace],
    );
};
